<script lang="ts" setup>
import type {
  EventMergeRecord,
  MutationsMerger,
} from '@gmao/shared';
import {
  getConflictResolve,
  getMergeConflictResolvesOptions,
  mergeConflictMessages,
} from '@gmao/shared';
import { Checkmark } from '@vicons/carbon';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
  event: EventMergeRecord;
  merger: MutationsMerger;
}>();

const emit = defineEmits<{
  (event: 'update:event', payload: EventMergeRecord): unknown;
}>();

const resolveType = ref<string | null>(props.event.conflicts![0].resolve?.type || null);

const type = computed(() =>
  resolveType.value
    ? 'default'
    : props.event.conflicts![0].type === 'duplicate'
      ? 'warning'
      : 'error',
);
const message = computed(() => {
  const conflictType = props.event.conflicts![0].type!;
  const reason = conflictType === 'rejectedByServer' ? props.event.rejection?.message : undefined;
  return reason ? `${mergeConflictMessages[conflictType]}: ${reason}` : mergeConflictMessages[conflictType];
});
const options = computed(() =>
  getMergeConflictResolvesOptions(props.event, props.event.conflicts![0]),
);

watch(resolveType, async (value) => {
  const clone = structuredClone(props.event);

  value
    ? (clone.conflicts![0].resolve = await getConflictResolve(value, props.event, props.merger))
    : (clone.conflicts![0].resolve = undefined);

  emit('update:event', clone);
});
</script>

<template>
  <n-alert
    :type="type"
    :title="message"
    :show-icon="false"
  >
    <template
      v-if="resolveType"
      #icon
    >
      <n-icon><Checkmark /></n-icon>
    </template>
    <template #header>
      <div
        flex
        items-center
        gap-2
      >
        <span
          min-w-200px
          flex-grow
        >{{ message }}</span>
        <n-select
          v-model:value="resolveType"

          placeholder="Please select resolution"
          :options="options"
          clearable
          flex-grow
        />
      </div>
    </template>
  </n-alert>
</template>
